(function() {
    'use strict';
    
    Utils.appHeight();

    const body = document.body;

    /**
     * Moving Background
     */
    const background = document.getElementById('coloured-background');

    const positionBackground = () => {
        const winScroll = document.body.scrollTop || document.documentElement.scrollTop;
        const height = document.documentElement.scrollHeight - document.documentElement.clientHeight;
        const scrolled = (winScroll / height) * 100;

        background.style.right = ((scrolled * 2) - 200) + 'vw';
    }

    document.addEventListener("scroll", () => {

        requestAnimationFrame(() => {

            positionBackground();

        });
    });

    /**
     * Video Overlay
     */
    const openOverlay = document.getElementById('open-video-overlay');
    const closeOverlay = document.getElementById('close-video-overlay');
    const overlayVideo = document.getElementById('overlay-video');
    const playVideo = document.getElementById('play-video');
    const videoContainer = document.querySelectorAll('.rsce-overlay__video-container');

    if (null !== openOverlay) {
        openOverlay.addEventListener('click', (e) => {
            e.currentTarget.closest('.video-container').classList.add('video-overlay--open');
        });

        closeOverlay.addEventListener('click', (e) => {
            e.currentTarget.closest('.video-container').classList.remove('video-overlay--open');
            overlayVideo.load();
            rememberClose();
        });

        playVideo.addEventListener('click', () => {
            if (overlayVideo.paused) {
                overlayVideo.play(); 
            } else {
                overlayVideo.pause();
            }
        });
    }

    const rememberClose = () => {
        window.localStorage.setItem('videoOverlayClosed', 'true');
    }

    window.onload = () => {
        if (window.localStorage.getItem('videoOverlayClosed') !== 'true') {
            console.log('dshould open');
            videoContainer.forEach((el) => {
                el.classList.add('video-overlay--open');
            });
        }
    }

    /**
     * RSCE Overlay
     */
     const openRSCEOverlay = document.querySelectorAll('.open-overlay-button');
     const closeRSCEOverlay = document.querySelectorAll('.close-overlay-button');

     openRSCEOverlay.forEach((button) => {
        button.addEventListener('click', () => {
            button.closest('.ce_rsce_overlay').classList.add('rsce-overlay--open');
        });
     });

     closeRSCEOverlay.forEach((button) => {
        button.addEventListener('click', () => {
            button.closest('.ce_rsce_overlay').classList.remove('rsce-overlay--open');
        });
     });

     /**
     *  Sharebuttons
     */

     const buttonContainer = document.querySelectorAll('.sharebuttons');
     buttonContainer.forEach((el) => {
        el.addEventListener('click', (e) => {
            if (e.currentTarget.parentNode.classList.contains('show-buttons')) {
                e.currentTarget.parentNode.classList.remove('show-buttons');
            } else {
                e.currentTarget.parentNode.classList.add('show-buttons');
            }
        })
     });

    /**
     *  Fade Switch Image
     */
    const switchContainer = document.querySelector('.masonry_mobile');
    if (window.outerWidth < 390) {
        setInterval(function() {
            switchContainer.classList.toggle('switch-image');
        }, 5000);
    }

    /**
     *  Youtube List - Play video
     */
    const youTubePlayButtons = document.querySelectorAll('.youtube__play-button');
    youTubePlayButtons.forEach((el) => {
        el.addEventListener('click', (e) => {
            const youTubeContainer = e.currentTarget.parentNode.parentNode;
            youTubeContainer.querySelectorAll('.youtube__thumbnail')[0].classList.add('hide-thumbnail');
            const youTubeIframe = youTubeContainer.querySelector('iframe');
            youTubeIframe.src += "&autoplay=1";
            e.preventDefault();
        });
    });

})();
